import React from "react";

import { Props } from "./types";
import classes from "./styles.scss";

function Skeleton(props: Props) {
  return (
    <div
      className={
        props.className
          ? [classes.skeleton, props.className].join(" ")
          : classes.skeleton
      }
      style={props.style}
    />
  );
}

export { Skeleton };
